










/**
 * Back button component
 * Move to the prevous/ parent URL
 *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/
import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import { NavigationStack } from "@/entities";

@Component({ components: {}})
export default class BackButtonComponent extends Vue {

    @Prop({ default: 'Back'  }) title: any

    /** back navigation */
    back() {
        var stack = new NavigationStack();

        const navigationItem = stack.pop();

        /* navigate to the previous route */
        if(navigationItem) {

            //@ts-ignore
            window.popStateDetected = true;

            this.$router.push({
                name: navigationItem.name,
                params: navigationItem.param,
                hash: navigationItem.hash
            });
        } else {
            this.$emit('back')
        }        
    }    
}
